// 0xd8dA6BF26964aF9D7eEd9e03E53415D37aA96045 ----> 0xd8dA...A96045
export function abbreviateHash(hash: string, prefixLength = 15, suffixLength = 15): string {
  if (hash === undefined) {
    return 'Loading...';
  }

  if (hash.length <= prefixLength + suffixLength) {
    return hash;
  }

  return `${hash.slice(0, prefixLength)}...${hash.slice(-suffixLength)}`;
}

export function wrapAsyncFunction<ARGS extends unknown[]>(
  fn: (...args: ARGS) => Promise<unknown>,
): (...args: ARGS) => void {
  return (...args) => {
    void fn(...args);
  };
}

export function removeVoid<T>(arr: (T | null | undefined)[]): T[] {
  return arr.flatMap((x) => (x === null || x === undefined ? [] : [x]));
}
